// Canvas calls the game draws with that older browsers lack (Chrome before 99,
// Safari before 16, as on Google Play's older test phones: Sentry
// ACHTUNG-ROYALE-7/9/D and -8/A/C). Without them a cosmetic head, a power-up
// token or an arena skin threw mid-frame and the rest of that frame went
// undrawn. Installed once at startup, only where missing.

type Ctx2D = CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;

// ctx.roundRect(x, y, w, h, radii): one radius or a list (the first is used for every corner).
function roundRect(this: Ctx2D | Path2D, x: number, y: number, w: number, h: number, radii?: number | DOMPointInit | (number | DOMPointInit)[]) {
  const first = Array.isArray(radii) ? radii[0] : radii;
  let r = typeof first === "number" ? first : first && typeof first.x === "number" ? first.x : 0;
  r = Math.max(0, Math.min(r, Math.abs(w) / 2, Math.abs(h) / 2));
  this.moveTo(x + r, y);
  this.lineTo(x + w - r, y);
  this.arcTo(x + w, y, x + w, y + r, r);
  this.lineTo(x + w, y + h - r);
  this.arcTo(x + w, y + h, x + w - r, y + h, r);
  this.lineTo(x + r, y + h);
  this.arcTo(x, y + h, x, y + h - r, r);
  this.lineTo(x, y + r);
  this.arcTo(x, y, x + r, y, r);
  this.closePath();
}

// ctx.createConicGradient(angle, x, y): approximated by a radial gradient from the
// same point (the colour stops land as rings instead of sweeping round), which
// keeps the drawing going with roughly the right colours.
function createConicGradient(this: Ctx2D, _angle: number, x: number, y: number): CanvasGradient {
  const r = Math.max(this.canvas.width, this.canvas.height);
  return this.createRadialGradient(x, y, 0, x, y, r);
}

export function installCanvasPolyfills(): void {
  if (typeof window === "undefined") return;
  const protos: any[] = [window.CanvasRenderingContext2D?.prototype, (window as any).OffscreenCanvasRenderingContext2D?.prototype, window.Path2D?.prototype];
  for (const p of protos) if (p && typeof p.roundRect !== "function") p.roundRect = roundRect;
  for (const p of protos.slice(0, 2)) if (p && typeof p.createConicGradient !== "function") p.createConicGradient = createConicGradient;
}
